// 店舗認証タブ用：認証ステータスによる絞り込み。
// linked_status === null を「未認証」、それ以外（"enabled" 想定）を「認証済」と扱う。
export const AUTH_STATUS_SEARCH_TYPE = {
  UNSPECIFIED: 'UNSPECIFIED',
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
  AUTHENTICATED: 'AUTHENTICATED',
} as const;

export type AuthStatusSearchType = keyof typeof AUTH_STATUS_SEARCH_TYPE;

export const authStatusSearchTypeMap = [
  {
    value: AUTH_STATUS_SEARCH_TYPE.UNSPECIFIED,
    label: '指定なし',
  },
  {
    value: AUTH_STATUS_SEARCH_TYPE.NOT_AUTHENTICATED,
    label: '未認証',
  },
  {
    value: AUTH_STATUS_SEARCH_TYPE.AUTHENTICATED,
    label: '認証済',
  },
];

// 連携ステータス更新タブ用：連携ステータスによる絞り込み。
// 店舗認証タブと同じ linked_status を判定軸とし、タブの語彙に合わせてラベルだけ
// 「連携中 / 未連携」に変える（is_order_manager の true/false 区別はフィルタには露出させない）。
export const INTEGRATION_STATUS_SEARCH_TYPE = {
  UNSPECIFIED: 'UNSPECIFIED',
  LINKED: 'LINKED',
  NOT_LINKED: 'NOT_LINKED',
} as const;

export type IntegrationStatusSearchType =
  keyof typeof INTEGRATION_STATUS_SEARCH_TYPE;

export const integrationStatusSearchTypeMap = [
  {
    value: INTEGRATION_STATUS_SEARCH_TYPE.UNSPECIFIED,
    label: '指定なし',
  },
  {
    value: INTEGRATION_STATUS_SEARCH_TYPE.LINKED,
    label: '連携中',
  },
  {
    value: INTEGRATION_STATUS_SEARCH_TYPE.NOT_LINKED,
    label: '未連携',
  },
];

// 店舗認証タブ用テーブルヘッダ。一括選択用のチェックボックス列＋店舗ステータス列を含む。
export const authTableThs = [
  {
    label: '全選択',
    minWidth: '50px',
  },
  {
    label: 'Uber Eats出店店舗名',
    minWidth: '200px',
  },
  {
    label: '店舗名',
    question: 'Camel上のデリバリーサービス出店名',
    minWidth: '200px',
  },
  {
    label: '拠点名',
    question: 'Camel上の実店舗名',
    minWidth: '200px',
  },
  {
    label: '店舗ステータス',
    minWidth: '100px',
  },
];

// 連携ステータス更新タブ用テーブルヘッダ。注文連携・メニュー連携の状態と個別操作列を含む。
export const statusUpdateTableThs = [
  {
    label: 'Uber Eats出店店舗名',
    minWidth: '200px',
  },
  {
    label: '店舗名',
    question: 'Camel上のデリバリーサービス出店名',
    minWidth: '200px',
  },
  {
    label: '拠点名',
    question: 'Camel上の実店舗名',
    minWidth: '200px',
  },
  {
    label: '注文連携',
    minWidth: '100px',
  },
  {
    label: 'メニュー連携',
    minWidth: '100px',
  },
  {
    label: '操作',
    question: '注文連携の有効/無効を個別に切替できます',
    minWidth: '180px',
  },
];
